import BaseScreen from './_base';

export default function CompanyScreen() {
  return <BaseScreen title="Company" description="Company analytics and rankings." />;
}
